import React, { useEffect, useState } from "react";
import Layout from "../components/app/Layout";
import api from "../lib/api";
import { useSite } from "../contexts/SiteContext";
import { fmtMoney } from "../lib/sports";
import { card } from "./EarningsPage";

export default function CustomersPage() {
  const { L } = useSite();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/customers").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  return (
    <Layout>
      <div className="max-w-5xl mx-auto space-y-6" data-testid="customers-page">
        <h1 className="font-oswald uppercase text-4xl">{L("Customers", "Клиенти")}</h1>
        {list && !list.length && <div className={card} data-testid="customers-empty">{L("Customers appear here after their first booking.", "Клиентите се появяват след първата резервация.")}</div>}
        <div className="space-y-2">
          {(list || []).map((c) => (
            <div key={c.customer_id} className={`${card} flex items-center gap-4`} data-testid={`customer-${c.customer_id}`}>
              <span className="w-10 h-10 rounded-full bg-pitch/20 text-pitch grid place-items-center font-bold">{c.name[0]}</span>
              <div className="flex-1 min-w-0"><p className="font-semibold truncate">{c.name}</p><p className="text-xs text-white/50">{c.bookings} {L("bookings", "резервации")} · {c.completed} {L("completed", "завършени")} · {L("last", "последна")} {c.last ? new Date(c.last).toLocaleDateString() : "—"}</p></div>
              <p className="text-sm font-semibold">{Object.entries(c.spent).map(([k, v]) => fmtMoney(v, k)).join(" + ") || "—"}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
